"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

const links = [
  ["בית", "/"],
  ["מערכות ופתרונות", "/systems"],
  ["לקוחות", "/customers"],
] as const;

export function Header() {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPath, setMenuPath] = useState(pathname);
  const toggleRef = useRef<HTMLButtonElement>(null);

  // Close the mobile menu whenever the route changes.
  if (menuPath !== pathname) {
    setMenuPath(pathname);
    setMenuOpen(false);
  }

  useEffect(() => {
    if (!menuOpen) return;
    function onKeyDown(event: KeyboardEvent) {
      if (event.key !== "Escape") return;
      setMenuOpen(false);
      toggleRef.current?.focus();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [menuOpen]);

  return (
    <header className={menuOpen ? "site-header is-menu-open" : "site-header"}>
      <div className="shell nav">
        <Link className="brand" href="/" aria-label="SenseMode — לדף הבית">
          <Image src="/sensemode-wordmark.png" width={284} height={87} priority alt="SenseMode" />
        </Link>
        <nav id="site-nav" className="site-nav" aria-label="ניווט ראשי">
          <ul>
            {links.map(([label, href]) => (
              <li key={href}>
                <Link
                  href={href}
                  aria-current={pathname === href ? "page" : undefined}
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        {pathname === "/contact" ? (
          <span className="nav-cta" aria-hidden="true" />
        ) : (
          <Link className="button button-small nav-cta" href="/contact">
            צור קשר
          </Link>
        )}
        <button
          ref={toggleRef}
          type="button"
          className="menu-toggle"
          aria-expanded={menuOpen}
          aria-controls="site-nav"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
          <span className="sr-only">{menuOpen ? "סגירת התפריט" : "פתיחת התפריט"}</span>
        </button>
      </div>
    </header>
  );
}
